//import Vue from 'vue';
//export default {
//    install(Vue, options) {
//        window.Components = {};
//        Vue.mixin({
//            data() {
//                return {
//                    is_data_ready: false,
//                    reload: 1,
//                    window: window
//                }
//            },
//            mounted() {
//                window.Components[this.$options.name + ''] = this;
//            },
//        });
//    }};




import Vue from 'vue';
export default {
    install(Vue, options) {
        
        Vue.mixin({
            data() {
                return {
                    is_data_ready: (isBrowser) ? false : true,
                    reload: 1,
                    window: (isBrowser) ? window : null,
                    global: global
                }
            },
            beforeCreate() {    //for SSR
                Components[this.$options.name + ''] = this;
            },
            mounted() {
                Components[this.$options.name + ''] = this;
            },
        });
    }};